import { PAY_ASSURANCE } from "@repo/constants/common";
const PaymentAssurance = ({
  locale
}) => {
  const isArabic = locale === "ar";
  return <div className="mx-auto flex flex-row flex-wrap items-center justify-center gap-1 md:justify-start md:whitespace-nowrap" data-sentry-component="PaymentAssurance" data-sentry-source-file="PaymentAssurance.jsx">
      {PAY_ASSURANCE.map(icon => {
      const IconComponent = icon.label === "TAMARA" && isArabic ? icon.arabicComponent : icon.component;
      return <div key={icon.id}>
            <IconComponent aria-label={icon.label} {...icon.label === "TAMARA" && {
          className: "w-16 md:ltr:w-20"
        }} />
          </div>;
    })}
    </div>;
};
export default PaymentAssurance;